module.exports = __webpack_public_path__ + "coin1.mp3";